import { CONVERSATIONS_SUMMARY_STATUS, NO_SUMMARY_MESSAGE, STATUS_TYPES } from 'helpers/sf_constants'
import { getPrimaryTextClass } from 'helpers/sf_utils'
import React from 'react'
import { UncontrolledTooltip } from 'reactstrap'
const SummaryDetails = ({ call_summary }) => {
    return (
        <React.Fragment>
            <div id="call-summary-details">
                <div className="d-flex align-items-center font-weight-semibold mt-2 mb-2">
                    <i className={`bx bx-list-ul ${getPrimaryTextClass()} font-size-26 me-2 bx-sm`} />
                    <h1 className="text-black text-start fs-16 mb-1 fw-bold mt-1">Summary</h1>
                    <i id='summary-tooltip' className='ms-1 bx bx-info-circle text-black bx-xs'></i>
                    <UncontrolledTooltip placement="top" target='summary-tooltip'>
                        Summary of the whole conversation
                    </UncontrolledTooltip>
                </div>

                {call_summary?.status === STATUS_TYPES.IN_PROGRESS || !call_summary || !call_summary?.status
                    ?
                    <div className='mt-3 ms-1 pending-summary-message'>{call_summary?.status === STATUS_TYPES.IN_PROGRESS ? CONVERSATIONS_SUMMARY_STATUS.IN_PROGRESS : CONVERSATIONS_SUMMARY_STATUS.PENDING}</div>
                    :
                    <div style={{ maxHeight: '240px', overflowY: 'auto', paddingBottom: '16px' }} className='text-justify'>
                        {call_summary?.summary ? (
                            <>
                                {
                                    call_summary.summary.includes("\n-") ? (
                                        <ul className="" style={{ padding: '0px 16px' }}>
                                            {(call_summary.summary || []).split("\n-").map((summary, index) => {
                                                return <li className='mt-2 me-2 ms-1' key={index}>{summary?.replace("-","")}</li>;
                                            })}
                                        </ul>
                                    ) : (
                                        <span className='mt-2 ms-1' style={{ display: 'inline-block' }}>{call_summary.summary}</span>
                                    )
                                }
                            </>
                        ) : (
                            <span className='mt-5 ms-1 text-black'>{NO_SUMMARY_MESSAGE}</span>
                        )}

                    </div>
                }
            </div>

        </React.Fragment>
    )
}

export default SummaryDetails
